import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

type Payload = [uui.domain.rm.TimeWindow?, uui.domain.rm.TimeWindow?]

/**
 * Update region
 *
 * @private
 */
export const updateTimeWindows = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/traffic/updateTimeWindows', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()
    const result = await rpc('rpc/traffic/updateTimeWindows', {
      category: 'rpc',
      type: 'rpc/traffic/updateTimeWindows',
      timeWindows: payload,
    })
    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {updateTimeWindows}`,
      { tags: ['rpc', 'traffic'], info: payload },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Update time windows failed`,
      error,
    })
  }
})
